<div class="row modal-bar">
  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-6">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<div class="table-responsive">
  <table class="rounded table text-dark table-striped clickable">
    <thead>
      <th>{{'SALES-ENTITY-MODIFICATION.DIALOG.HEADER.DISCOUNT' | translate}}</th>
      <th class="text-end">{{'SALES-ENTITY-MODIFICATION.DIALOG.HEADER.AMOUNT' | translate}}</th>
    </thead>

    <tbody>
      @if (this.pagedDiscountLines.length == 0) {
        <tr>
          <td colspan="2">{{'SALES-ENTITY-MODIFICATION.DIALOG.LISTVIEW.NO-DISCOUNT-ON-ORDER' | translate}}</td>
        </tr>
      } @else {
        @for (d of pagedDiscountLines; track d) {
          <tr>
            <td>{{ d.DiscountName | replaceOnEmpty}}</td>
            <td style="width: 80px" class="text-end">{{d.Amount | currency:'EUR'}}</td>
            <td class="grid-action" >
              <button (click)="removeDiscountCode(d.DiscountCodeId)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

<t4-pager [listCounts]="false" (onPage)="doPageForDiscounts($event)" #pagerComponentForDiscounts></t4-pager>
